import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    value: ''
}

const cardTextSlice = createSlice({
    name: 'cardText',
    initialState,
    reducers: {
        setTextToSearch: (state, action) => {
            state.value = action.payload
        }
    }
})

export const { setTextToSearch } = cardTextSlice.actions;
export default cardTextSlice.reducer